import { render, staticRenderFns } from "./Table-App.vue?vue&type=template&id=121967d1&"
import script from "./Table-App.vue?vue&type=script&lang=js&"
export * from "./Table-App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports